import React from 'react';

const PieceBracodeTrackingComponentLoadable = React.lazy(() => import('./PieceBracodeTrackingComponent'));

export {
    PieceBracodeTrackingComponentLoadable
};
